<div class="relative min-h-screen text-white">

    <div class="overflow-hidden">
        <app-fp-navbar />
        <router-outlet />
        <app-fp-footer />
    </div>

</div>